var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#57B9DC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.898 9.912a11.854 11.854 0 0 0-3.707-6.798 11.862 11.862 0 0 0-8.023-3.116c-2.296 0-4.534.659-6.451 1.9a11.842 11.842 0 0 0-3.86 4.062 6.52 6.52 0 0 0-7.76 6.392c0 .465.051.912.135 1.351A9.06 9.06 0 0 0 .5 21.008c0 2.339.87 4.61 2.457 6.41 1.63 1.84 3.783 2.93 6.08 3.056H16.367c.633 0 1.14-.507 1.14-1.14 0-.633-.507-1.14-1.14-1.14H9.14C5.685 27.983 2.78 24.698 2.78 21c0-2.39 1.284-4.619 3.352-5.826a1.15 1.15 0 0 0 .499-1.385 4.238 4.238 0 0 1 5.421-5.43 1.145 1.145 0 0 0 1.427-.583 9.648 9.648 0 0 1 8.698-5.514 9.565 9.565 0 0 1 9.567 8.681c.051.515.44.929.946 1.013 3.758.642 6.595 4.113 6.595 8.073 0 4.197-3.301 7.845-7.372 8.158H25.69c-.634 0-1.14.506-1.14 1.14 0 .633.506 1.14 1.14 1.14h6.35c2.576-.186 4.982-1.368 6.772-3.344a10.516 10.516 0 0 0 2.753-7.094c-.008-4.737-3.242-8.95-7.667-10.116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.198 34.413a1.137 1.137 0 0 0 0 1.613l6.037 6.038a1.118 1.118 0 0 0 1.604 0l6.039-6.038a1.137 1.137 0 0 0 0-1.613 1.147 1.147 0 0 0-.803-.337c-.287 0-.582.11-.802.337l-4.095 4.096V19.686c0-.633-.507-1.14-1.14-1.14-.634 0-1.14.507-1.14 1.14V38.51l-4.096-4.096a1.126 1.126 0 0 0-1.604 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0fbedf89e92bf53d5d1292a9c41c8afa.svg";
export { ForwardRef as ReactComponent };